// in DE, grade ids within 1-10 must be grouped in ranges
const CLASS_IDS_RANGE = { min: 1, max: 10 };

// in DE, the 'Vorschule' must always be placed before classes 1-10
export const VORSCHULE_ID = 17;

const isDEClass = (id: number) => id >= CLASS_IDS_RANGE.min && id <= CLASS_IDS_RANGE.max;

export default isDEClass;
